/**
 * * Error handling utilities
 */

/**
 * * Extract error message from various error types
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message
  }
  
  if (typeof error === 'object' && error !== null) {
    // * Axios error
    if ('response' in error) {
      const axiosError = error as { response?: { data?: { message?: string } } }
      return axiosError.response?.data?.message || 'Erreur inconnue'
    }
    
    // * Error object with message property
    if ('message' in error) {
      return String(error.message)
    }
  }
  
  return 'Erreur inconnue'
}

/**
 * * Show error alert to user
 */
export function showErrorAlert(error: unknown, defaultMessage: string = 'Une erreur est survenue'): void {
  const message = getErrorMessage(error)
  alert(`❌ ${defaultMessage}: ${message}`)
}

/**
 * * Show success alert to user
 */
export function showSuccessAlert(message: string): void {
  alert(`✅ ${message}`)
}

/**
 * * Log error to console with context
 */
export function logError(context: string, error: unknown): void {
  const message = getErrorMessage(error)
  console.error(`[${context}] ${message}`, error)
}
